'use strict';

let topScroll = 0;
let isScrollDisabled = false;

/**
 * This will disable window from scrolling, used for modals, popups, fixed elements
 */
const disableScroll = () => {
    if (!isScrollDisabled) {
        topScroll = $(window).scrollTop();
        $('body').css({
            'top': -topScroll + 'px'
        }).addClass('no-scroll');
        $('html').css({
            'height': '100vh'
        });

        isScrollDisabled = true;
    }
};

/**
 * This will enable window to scroll, remembering the previous top scroll offset
 */
const enableScroll = () => {
    $('body').removeAttr('style').removeClass('no-scroll');
    $('html').removeAttr('style');

    isScrollDisabled = false;
    if (topScroll !== 0) {
        $(window).scrollTop(topScroll);
        isScrollDisabled = false;
        topScroll = 0;
    }
};

/**
 * Disables the scrolling by mouse keyboard or touch on an element
 *
 * @param {String} el Selector of element to block scroll on
 */
const disableScrollEventsOnEl = (el) => {
    $(el).on('wheel.helpers mousewheel.helpers touchmove.helpers', (e) => {
        e.preventDefault();
        return false;
    });

    $(document).on('keydown.helpers', (e) => {
        const keys = {
            32: 1, // Spacebar
            33: 1, // PageUp
            34: 1, // PageDown
            35: 1, // End
            36: 1, // Home
            38: 1, // Up
            40: 1 // Down
        };

        if (keys[e.keyCode]) {
            e.preventDefault();
            return false;
        }
    });
};

/**
 * Enables the events that where disables in disableScrollEventsOnEl
 *
 * @param {String} el Selector of element to remove events set in disableScrollEventsOnEl
 */
const enableScrollEventsOnEl = (el) => {
    $(el).off('wheel.helpers mousewheel.helpers touchmove.helpers');
    $(document).off('keydown.helpers');
};

/**
 * @function
 * @description Scrolls a browser window to a given x point
 * @param {String} The x coordinate
 */
const scrollSmooth = (xLocation) => {
    const headerH = $('header.header').outerHeight();
    $('html, body').animate({scrollTop: xLocation - headerH}, 500);
};

module.exports = {
    enableScroll: enableScroll,
    disableScroll: disableScroll,
    enableScrollEventsOnEl: enableScrollEventsOnEl,
    disableScrollEventsOnEl: disableScrollEventsOnEl,
    smoothScroll: scrollSmooth
};
